export var getCostPerExtraGuestString = function getCostPerExtraGuestString(cost, costPerExtraGuestLabel) {
  return "".concat(cost, " / ").concat(costPerExtraGuestLabel);
};